export default "__VITE_ASSET__BnUs59kj__"